import { Graphics } from "pixi.js";
import DisplayContainer from "../components/DisplayContainer";
import DisplayContainerOptions from "../interfaces/DisplayContainerOptions";
import AppModel from "../models/AppModel";
import { AssessmentPart, AssessmentSection } from "../models/AssessmentData";
import ActivityContainer from "../components/ActivityContainer";
import MultipleChoice from "./MultipleChoice";
import SpeechRecog from "./SpeechRecog";
import SoundManager from "../managers/SoundManager";

export default class Assessment extends DisplayContainer {

    private bg: Graphics;
    private model: AppModel;
    private sections: AssessmentSection[];
    private parts: AssessmentPart[];
    private currentInstructionAudio: string;
    private playedFirst: boolean;
    private assessmentComplete: Function;

    private currentActivity: ActivityContainer;

    constructor(sections: AssessmentSection[], completeFunction: Function, options?: DisplayContainerOptions) {
        super();
        this.sections = sections;
        this.assessmentComplete = completeFunction;
        //this.readyFunction = readyFunction;
        if (options) {
            this.options = options;
        }
        else {
            this.setDefaultOptions();
        }
        this._init();
    }

    private _init() {
        this.label = "Menu";
        this.model = AppModel.getInstance();
        this.playedFirst = false;
        this.currentInstructionAudio = "";
        if (this.options.autoCreate) {
            this.create(this.options.showAfterCreate);
        }
    }

    private cleanData(): void {
        this.parts = [];
        const numSections = this.sections.length;
        for (let i = 0; i < numSections; i++) {
            const curSection = this.sections[i];
            if (!!curSection.audio) {
                this.currentInstructionAudio = curSection.audio;
            }
            if (curSection.isComplete === false) {
                const numParts = curSection.parts.length;
                for (let j = 0; j < numParts; j++) {
                    const curPart = curSection.parts[j];
                    if (curPart.isComplete === false) {
                        this.parts.push(curPart);
                    }
                }
            }
        }
    }

    private createBackground(): void {
        this.bg = new Graphics();
        this.bg.fill(0xFFFFFF);//.fill(0x3498db);
        this.bg.rect(0, 0, this.model.stageWidth, this.model.stageHeight);
        this.bg.fill();
        this.addChild(this.bg);
    }

    private partComplete = (endEarly: boolean): void => {
        this.removeChild(this.currentActivity);
        this.playedFirst = true;
        if (endEarly) {

        } else {
            this.parts.shift();
            if (this.parts.length > 0) {
                this.playNextPart();
            } else {
                this.assessmentComplete();
            }
        }
    }

    private playNextPart(): void {
        const curPart = this.parts[0];
        switch (curPart.interactionType) {
            case 1:
                this.currentActivity = new MultipleChoice(curPart, this.partComplete);
                this.addChild(this.currentActivity);
                break;
            case 2:
                this.currentActivity = new SpeechRecog(curPart, this.partComplete, !this.playedFirst);
                this.addChild(this.currentActivity);
                break;
            case 3:
                this.partComplete(false);
                alert('spelling not yet implemented')
                break;
            default:
                alert('unkown interaction type:' + curPart.interactionType);
        }
    }

    private setDefaultOptions(): void {
        this.options = {
            autoCreate: true,
            showAfterCreate: true
        };
    }

    //----------------------------------
    //  Public:
    //----------------------------------

    public override create(showAfterCreate: boolean = true): void {
        this.createBackground();
        this.cleanData();
        //this.playAudio();
        this.playNextPart();
        if (showAfterCreate) {
            this.show();
        }
    }

    public override destroy(): void {
        super.destroy();
    }
}